import { Colors } from "@auteco/theme";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
    mainContainer: {
        margin: '20px 0 0',
        padding: '12px',
    },
    barContainer: {
        display: 'grid',
        alignItems: 'center',
        gridGap: '4px',
        margin: '12px 0 20px',
        gridTemplateColumns: '0.5fr 3fr 1fr',
        width: '800px',
    },
    bar: {
        display: 'flex',
        height: '40px',
        // boxShadow: '0px 0px 10px grey',
        borderRadius: '4px',
        overflow: 'hidden'
    },
    completeSection: {
        display: 'flex',
        justifyContent: 'end',
        alignItems: 'center',
        position: 'relative',
        background: 'linear-gradient(to right, #ffca69, #FFA500)',
        paddingRight: '8px'
    },
    emptySection: {
        background: Colors.GRAY_BACKGROUND
    },
    totalTxtContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '8px'
    },
    totalTxt: {
        fontWeight: 'bold',
        fontSize: '18px',
        color: 'grey'
    },
    totalTxtPercent: {
        fontWeight: 'bold',
        fontSize: '18px',
    },
}))

export default useStyles